import { Button } from "@/components/ui/button";
import moment from "moment";

export function AssetDetailHandler({ currentExport, data, dataSave, exportToExcel }) {
  if (currentExport == "asset") {
    const exportData = dataSave.assets
      .filter((obj) => {
        if (data.location_id && data.location_type) {
          return (
            obj.location_id == data.location_id &&
            obj.location_type == data.location_type
          );
        } else {
          return true;
        }
      })
      .map((obj) => {
        return {
          "Asset Name": obj.asset_details.name,
          "Asset Number": obj.asset_details.asset_number,
          "Asset SN": obj.asset_sn,
          Condition: obj.status,
          "Location Base": obj.location_type,
          "Location Name": obj.locations.name,
          "Received Date": obj.received_at
            ? moment(obj.received_at)
                .subtract(7, "hours")
                .format("YYYY-MM-DD HH:mm:ss")
            : "-",
          "Warranty Period Months": obj.warranty_period_months,
          "Warranty Ends Date": obj.warranty_end_at
            ? moment(obj.warranty_end_at)
                .subtract(7, "hours")
                .format("YYYY-MM-DD HH:mm:ss")
            : "-",
          "Expiry Period Months": obj.expiry_period_months,
          "Expired Date": obj.expired_at
            ? moment(obj.expired_at)
                .subtract(7, "hours")
                .format("YYYY-MM-DD HH:mm:ss")
            : "-",
          Notes: obj.notes,
        };
      });

    return (
      <Button
        variant="primary"
        onClick={() =>
          exportToExcel(
            exportData,
            `asset_${moment().format("hhmm_DDMMYYYY")}.xlsx`,
          )
        }
      >
        Submit
      </Button>
    );
  }
  return null;
}
